import React, { useContext } from 'react';
import { withTheme } from 'styled-components';

import { Context } from '@store/store';

import Button from './icons';
import {
  StyledButtons,
  StyledRowButtons,
} from './footer-buttons.styles';

const FooterButtons = ({ theme }) => {
  const [state, dispatch] = useContext(Context);

  return (
    <>
      <StyledButtons>
        <StyledRowButtons>
          {state.currentPage === 0 ? null : (
            <Button
              onClick={() => {
                dispatch({ type: 'SET_PREV_PAGE' });
              }}
              title={
                state.isSinglePageMode
                  ? 'Перейти на предыдущую страницу'
                  : 'Перейти на предыдущие страницы'
              }
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 19 39"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.8611 1.02381C16.4002 0.394824 17.3472 0.321982 17.9762 0.861115C18.6052 1.40025 18.678 2.3472 18.1389 2.97619L15.8611 1.02381ZM2 19.5L0.861115 20.4762L0.0243835 19.5L0.861115 18.5238L2 19.5ZM18.1389 36.0238C18.678 36.6528 18.6052 37.5998 17.9762 38.1389C17.3472 38.678 16.4002 38.6052 15.8611 37.9762L18.1389 36.0238ZM18.1389 2.97619L3.13888 20.4762L0.861115 18.5238L15.8611 1.02381L18.1389 2.97619ZM15.8611 37.9762L0.861115 20.4762L3.13888 18.5238L18.1389 36.0238L15.8611 37.9762Z"
                  fill={theme.themeColors.arrowButtons.color}
                />
              </svg>
            </Button>
          )}
          {state.isSinglePageMode ? (
            state.currentPage === state.pagesCount - 1 ? null : (
              <Button
                onClick={() => {
                  dispatch({ type: 'SET_NEXT_PAGE' });
                }}
                title={
                  state.isSinglePageMode
                    ? 'Перейти на следующую страницу'
                    : 'Перейти на следующие страницы'
                }
              >
              <svg
                width="20"
                height="20"
                viewBox="0 0 19 39"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.13888 1.02381C2.59975 0.394824 1.6528 0.321982 1.02381 0.861115C0.394824 1.40025 0.321982 2.3472 0.861115 2.97619L3.13888 1.02381ZM17 19.5L18.1389 20.4762L18.9756 19.5L18.1389 18.5238L17 19.5ZM0.861115 36.0238C0.321982 36.6528 0.394824 37.5998 1.02381 38.1389C1.6528 38.678 2.59975 38.6052 3.13888 37.9762L0.861115 36.0238ZM0.861115 2.97619L15.8611 20.4762L18.1389 18.5238L3.13888 1.02381L0.861115 2.97619ZM3.13888 37.9762L18.1389 20.4762L15.8611 18.5238L0.861115 36.0238L3.13888 37.9762Z"
                  fill={theme.themeColors.arrowButtons.color}
                />
              </svg>
              </Button>
            )
          ) : state.currentPage === state.pagesCount - 1 ? null : (
            <Button
              onClick={() => {
                dispatch({ type: 'SET_NEXT_PAGE' });
              }}
              title={
                state.isSinglePageMode
                  ? 'Перейти на следующую страницу'
                  : 'Перейти на следующие страницы'
              }
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 19 39"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.13888 1.02381C2.59975 0.394824 1.6528 0.321982 1.02381 0.861115C0.394824 1.40025 0.321982 2.3472 0.861115 2.97619L3.13888 1.02381ZM17 19.5L18.1389 20.4762L18.9756 19.5L18.1389 18.5238L17 19.5ZM0.861115 36.0238C0.321982 36.6528 0.394824 37.5998 1.02381 38.1389C1.6528 38.678 2.59975 38.6052 3.13888 37.9762L0.861115 36.0238ZM0.861115 2.97619L15.8611 20.4762L18.1389 18.5238L3.13888 1.02381L0.861115 2.97619ZM3.13888 37.9762L18.1389 20.4762L15.8611 18.5238L0.861115 36.0238L3.13888 37.9762Z"
                  fill={theme.themeColors.arrowButtons.color}
                />
              </svg>
            </Button>
          )}
        </StyledRowButtons>
        <StyledRowButtons>
          <Button
            onClick={() => dispatch({ type: 'ROTATE_PAGE', payload: 90 })}
            title="Повернуть страницу на 90 градусов"
          >
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.3852 13.952C17.7448 15.7719 16.531 17.3342 14.9265 18.4034C13.3222 19.4727 11.4141 19.9909 9.49009 19.88C7.56595 19.7691 5.72994 19.0352 4.25867 17.7887C2.78741 16.5423 1.76059 14.8508 1.33294 12.9693C0.905285 11.0878 1.09996 9.11806 1.88765 7.35696C2.67532 5.59583 4.01332 4.1387 5.70005 3.20513C7.38678 2.27157 9.33088 1.91212 11.2393 2.18096C14.4616 2.63485 16.5903 4.97331 18.8891 7.03875M18.8891 7.03875V1.10522M18.8891 7.03875H12.9632" stroke={theme.themeColors.zoomButtons.iconColor} strokeWidth="1.5"/>
            </svg>
          </Button>
          <Button
            onClick={() => dispatch({ type: 'ZOOM_IN_OUT', payload: 0.2 })}
            title="Увеличить масштаб страниц(ы)"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line
                x1="1"
                y1="9.125"
                x2="17"
                y2="9.125"
                stroke={theme.themeColors.zoomButtons.iconColor}
                strokeWidth="2"
                strokeLinecap="round"
              />
              <line
                x1="9.125"
                y1="17"
                x2="9.125"
                y2="1"
                stroke={theme.themeColors.zoomButtons.iconColor}
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </Button>
          <Button
            onClick={() => dispatch({ type: 'ZOOM_IN_OUT', payload: -0.2 })}
            title="Уменьшить масштаб страниц(ы)"
          >
            <svg
              width="18"
              height="2"
              viewBox="0 0 18 2"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line
                x1="1"
                y1="1"
                x2="17"
                y2="1"
                stroke={theme.themeColors.zoomButtons.iconColor}
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </Button>
        </StyledRowButtons>
      </StyledButtons>
    </>
  );
};

export default withTheme(FooterButtons);
